module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pid-overwrite-form"
  }, [_c('div', {
    staticClass: "pid-overwrite-form__header mt-2 mb-4"
  }, [_vm._v("\n    Select the quarters you wish to include/overwrite with your new PID list\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "table-body"
  }, [_c('v-simple-table', {
    attrs: {
      "height": "500px",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("\n              Quarter\n            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("\n              Exists\n            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("\n              Include/Overwrite\n            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item) {
          return _c('tr', {
            key: item.quarter
          }, [_c('td', [_vm._v("\n              " + _vm._s(item.quarter) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
            staticClass: "d-flex justify-center"
          }, [_c('v-checkbox', {
            attrs: {
              "disabled": ""
            },
            model: {
              value: (item.exists),
              callback: function($$v) {
                _vm.$set(item, "exists", $$v)
              },
              expression: "item.exists"
            }
          })], 1)]), _vm._v(" "), _c('td', [_c('div', {
            staticClass: "d-flex justify-center"
          }, [_c('v-checkbox', {
            model: {
              value: (item.override),
              callback: function($$v) {
                _vm.$set(item, "override", $$v)
              },
              expression: "item.override"
            }
          })], 1)])])
        }), 0)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('action-button', {
    attrs: {
      "label": "Process",
      "color": "secondary",
      "id": "pidAppendProcessBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.overwriteFiles.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-162bfb9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/forms/PidOverwriteForm.vue
// module id = 1821
// module chunks = 0